import AnnualSummaryError from './AnnualSummaryError';
class AnnualSummaryYearsExceeds extends AnnualSummaryError {
    numberOfYears;
    constructor(numberOfYears, options) {
        super('The number of years exceeds the crowdfunding property sale date', options);
        this.numberOfYears = numberOfYears;
    }
}
export default AnnualSummaryYearsExceeds;
